import { useCallback, useEffect, useState } from 'react';
import { checkVpnEnabled } from '../utils/detectVpn';

export default function useVpnHint() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const controller = new AbortController();

        checkVpnEnabled(controller.signal).then((enabled) => {
            if (!controller.signal.aborted && enabled) setVisible(true);
        });

        return () => controller.abort();
    }, []);

    useEffect(() => {
        document.body.classList.toggle('vpn-hint', visible);
        return () => document.body.classList.remove('vpn-hint');
    }, [visible]);

    const dismiss = useCallback(() => {
        setVisible(false);
    }, []);

    return { visible, dismiss };
}
